import { render, staticRenderFns } from "./nui_dialog.vue?vue&type=template&id=5fb6234b&scoped=true"
import script from "./nui_dialog.vue?vue&type=script&lang=js"
export * from "./nui_dialog.vue?vue&type=script&lang=js"
import style0 from "./nui_dialog.vue?vue&type=style&index=0&id=5fb6234b&prod&lang=scss&scoped=true"
import style1 from "./nui_dialog.vue?vue&type=style&index=1&id=5fb6234b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6234b",
  null
  
)

export default component.exports